import Total from '../../old-reports/class/total';

export default function TotalReport() {
	return <Total/>;
}